import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-container">
          <div className="newsletter-section">
            <div className="newsletter-text">
              <h2>Get Connect</h2>
              <p>
                draft@pedarcircle.club
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-middle">
        <div className="footer-container">
          <div className="footer-columns">
            <div className="footer-col">
              <h3>Support</h3>
              <ul>
                <li>
                  <Link to="/contact" onClick={toTop}>
                    Contact Us
                  </Link>
                </li>

                <li>
                  <Link to="/returns" onClick={toTop}>
                    Refund Policy
                  </Link>
                </li>
                <li>
                  <Link to="/shipping" onClick={toTop}>
                    Shipping Policy
                  </Link>
                </li>
                <li>
                  <Link to="/faqs" onClick={toTop}>
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-col">
              <h3>About us</h3>
              <ul>
                <li>
                  <Link to="/about" onClick={toTop}>
                    Our Story
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="bottom-content">
            <div className="legal-links">
              <Link to="/terms" onClick={toTop}>
                Terms & Conditions
              </Link>
              <Link to="/privacy" onClick={toTop}>
                Privacy Policy
              </Link>
              <Link to="/cookies" onClick={toTop}>
                Cookie Policy
              </Link>
            </div>
            <div className="copyright">
              © 2026 Pedarcircle. All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
